import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import StockStatusTable from '../../../components/StockStatusTable';
import RaisePOModal from '../../../RaisePOModal';

function JobMaterialsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [showRaisePOModal, setShowRaisePOModal] = useState(false);
  const [shortageItems, setShortageItems] = useState([]);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Tab Bar */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-full mx-auto px-6 flex items-center gap-1">
          <TabLink to={`/jobs/${id}`} label="Job Details" />
          <TabLink to={`/jobs/${id}/appointments`} label="Appointments" />
          <TabLink to={`/jobs/${id}/materials`} label="Materials" active />
          <TabLink to={`/jobs/${id}/rams`} label="RAMS" />
        </div>
      </div>

      <div className="p-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Materials & Stock Status</h3>
          <StockStatusTable
            type="job"
            id={id}
            onRaisePO={(items) => {
              setShortageItems(items);
              setShowRaisePOModal(true);
            }}
          />
        </div>
      </div>

      {showRaisePOModal && (
        <RaisePOModal
          shortageItems={shortageItems}
          linkedTo="job"
          linkedId={id}
          onClose={() => setShowRaisePOModal(false)}
          onSuccess={(result) => {
            setShowRaisePOModal(false);
            alert(`Successfully created ${result.count} purchase order(s)!`);
            window.location.reload();
          }}
        />
      )}
    </div>
  );
}

function TabLink({ to, label, active }) {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(to)}
      className={`px-4 py-3 text-sm font-medium border-b-2 transition ${
        active
          ? 'border-blue-600 text-blue-700'
          : 'border-transparent text-gray-500 hover:text-gray-700'
      }`}
    >
      {label}
    </button>
  );
}

export default JobMaterialsPage;
